<app-header>
  <button
    class="menu-toggle-btn"
    type="button"
    mat-icon-button
    (click)="sidenav.toggle()"
  >
    <mat-icon>menu</mat-icon>
  </button>
</app-header>

<mat-toolbar
  class="mobile-menu"
  [class.hide]="showMenuInFooter"
  id="mobile-menu"
  *ngIf="authenticator.route === 'authenticated'"
>
  <mat-toolbar-row class="p-0">
    <app-header-menu [footer]="true"></app-header-menu>
  </mat-toolbar-row>
</mat-toolbar>

<mat-sidenav-container class="layout-container" autosize>
  <mat-sidenav
    #sidenav
    [(opened)]="isSidenavOpen"
    class="layout-container__sidenav"
    [ngClass]="{
      authenticated: authenticator.route === 'authenticated',
      'over-mode': sidenavMode === 'over'
    }"
    [mode]="sidenavMode"
    [attr.color]="'primary'"
    [disableClose]="true"
  >
    <ng-container
      *ngIf="
        authenticator.route !== 'authenticated' ||
        roles.includes('EASYLOT_ADMIN') ||
        roles.includes('TELESALES') ||
        roles.includes('IMPERSONATION')
      "
    >
      <button
        type="button"
        mat-icon-button
        *ngIf="sidenavMode === 'over' && isSidenavOpen"
        class="close-x"
        (click)="closeSidenav()"
      >
        <mat-icon>close</mat-icon>
      </button>

      <app-sidenav (heightChanged)="sidenavHeight = $event"></app-sidenav>
    </ng-container>
  </mat-sidenav>

  <mat-sidenav-content
    #sidenavContent
    class="layout-container__content"
    [class.site-selected]="siteSelected$ | async"
    [style.min-height.px]="sidenavHeight + 100"
  >
    <main
      class="main-content d-flex flex-column"
      [ngClass]="{ 'over-mode': sidenavMode === 'over' }"
    >
      <app-maintenance-banner></app-maintenance-banner>

      <app-ad-banner
        *ngIf="!hasSearchLayout && hasBanner"
        [ngClass]="
          authenticator.route === 'authenticated' || !isSidenavOpen
            ? ''
            : 'small'
        "
      ></app-ad-banner>

      <app-breadcrumb
        *ngIf="!hasSearchLayout && authenticator.route === 'authenticated'"
      ></app-breadcrumb>
      <router-outlet class="main-router-outlet"></router-outlet>
    </main>
  </mat-sidenav-content>
</mat-sidenav-container>
<app-footer id="easy-footer" [showMenuInFooter]="showMenuInFooter"></app-footer>
